import { ApplicationController } from 'stimulus-use';

export default class extends ApplicationController {
  connect() {
    window.turnstile.render('.cf-turnstile');
  }
}
